import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "frame"]

  open(event) {
    event.preventDefault()
    const channelId = event.currentTarget.dataset.channelId
    const channelName = event.currentTarget.dataset.channelName
    const url = `/admin/announcements/channel_modal?channel_id=${channelId}`

    this.frameTarget.src = url
    this.modalTarget.querySelector(".announcement-modal__channel-name").textContent = channelName
    this.modalTarget.classList.add("is-active")
  }

  close() {
    this.modalTarget.classList.remove("is-active")
  }

  closeOnBackground(event) {
    if (event.target === event.currentTarget) {
      this.close()
    }
  }
}
